import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Apps.css';

const Apps = () => {
    const navigate = useNavigate();

    return (
        <div className="apps">
            <div className="apps-header">
                <h1>Apps</h1>
            </div>
            <div className="apps-container">
                <div className="app-item">
                    <div className="app-card">
                        <h2>
                            <a 
                                href="https://apps.apple.com/us/app/stock-tracker/id6756502700" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="app-title-link"
                            >
                                Stock Tracker
                            </a>
                        </h2>
                        <p className="app-platform">iOS App</p>
                        <p className="app-description">Track and monitor your stock portfolio on iOS devices</p>
                        <div className="app-links">
                            <a 
                                href="/privacy/stock-tracker" 
                                onClick={(e) => {
                                    e.preventDefault();
                                    navigate('/privacy/stock-tracker');
                                }}
                                className="app-link"
                            >
                                Privacy Policy
                            </a>
                            <a 
                                href="/wiki/stock-tracker" 
                                onClick={(e) => {
                                    e.preventDefault();
                                    navigate('/wiki/stock-tracker');
                                }}
                                className="app-link"
                            >
                                Wiki
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Apps;

